<script lang="ts">

  import Calendar1Icon from "@lucide/svelte/icons/calendar-1"
  import CalendarCheckIcon from "@lucide/svelte/icons/calendar-check"
  import CalendarRangeIcon from "@lucide/svelte/icons/calendar-range"
  import CalendarX2Icon from "@lucide/svelte/icons/calendar-x-2"
  import SquareChartGanttIcon from "@lucide/svelte/icons/square-chart-gantt"
  import MenuItem from "../../_components/menu-item.svelte"

  let { prefix }: { prefix: string } = $props()
  const items = [
    { path: "activity-recap", label: "Rekap", icon: SquareChartGanttIcon },
    { path: "activity-plan", label: "Rencana", icon: CalendarRangeIcon },
    { path: "activity-unplan", label: "Tidak Terencana", icon: Calendar1Icon },
    { path: "activity-realization", label: "Realisasi", icon: CalendarCheckIcon },
    { path: "activity-problem", label: "Kendala", icon: CalendarX2Icon },
  ]

</script>

<div class="mx-3">
  <h3 class="mb-2 text-sm font-semibold">Aktifitas</h3>
  <div class="grid grid-cols-5 justify-items-stretch gap-4">
    {#each items as item (item.path)}
      <MenuItem
        prefix={prefix}
        {...item}/>
    {/each}
  </div>
</div>
